interface ResourceCounterProps {
  icon: string
  type: "SEEDmons" | "SEEDtrees"
  count: number
}

export function ResourceCounter({ icon, type, count }: ResourceCounterProps) {
  return (
    <div className="bg-white rounded-full px-4 py-2 flex items-center gap-3 shadow-sm">
      <img src={icon} alt={type} className="w-10 h-10" />
      <div>
        <div className="text-gray-600">{type}</div>
        <div className="text-xl font-bold">{count}</div>
      </div>
    </div>
  )
}

